import { render, staticRenderFns } from "./ImagensAnexoCCS.vue?vue&type=template&id=204f4b1a&scoped=true"
import script from "./ImagensAnexoCCS.vue?vue&type=script&lang=js"
export * from "./ImagensAnexoCCS.vue?vue&type=script&lang=js"
import style0 from "./ImagensAnexoCCS.vue?vue&type=style&index=0&id=204f4b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204f4b1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VCol,VImg,VRow})
